<p-dialog
  [visible]="visible"
  (visibleChange)="visible = $event; !$event && close()"
  [header]="matrix()?.name ?? ('VARIANT_PICKER.TITLE' | translate)"
  [modal]="true"
  [closable]="true"
  [style]="{ width: 'min(560px, 96vw)' }"
  [dismissableMask]="true"
>
  @if (loading()) {
    <div class="flex items-center justify-center py-12 text-gray-400">
      <i class="pi pi-spin pi-spinner text-2xl"></i>
    </div>
  } @else if (matrix(); as m) {
    <div class="flex flex-col gap-5 pt-1">
      @for (axis of m.attributes; track axis.attributeId) {
        <div class="flex flex-col gap-2">
          <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">
            {{ axis.attributeName }}
          </span>
          <div class="flex flex-wrap gap-2">
            @for (val of axis.values; track val.valueId) {
              @let stock = stockForValue(axis.attributeId, val.valueId);
              @let out = stock === 0;
              <button
                type="button"
                (click)="!out && selectValue(axis.attributeId, val.valueId)"
                [disabled]="out"
                [class]="
                  isSelected(axis.attributeId, val.valueId)
                    ? 'flex items-center gap-2 px-3.5 py-2 rounded-lg border-2 border-primary-500 bg-primary-50 dark:bg-primary-950 text-primary-700 dark:text-primary-300 text-sm font-medium transition-all'
                    : out
                      ? 'flex items-center gap-2 px-3.5 py-2 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-300 dark:text-gray-600 text-sm line-through cursor-not-allowed'
                      : 'flex items-center gap-2 px-3.5 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 text-sm font-medium hover:border-primary-400 transition-all'
                "
              >
                @if (val.extra) {
                  <span
                    class="w-3.5 h-3.5 rounded-full border border-black/10"
                    [style.background]="val.extra"
                  ></span>
                }
                <span>{{ val.value }}</span>
                @if (stock !== null) {
                  <span [class]="out ? 'text-[11px] text-red-400' : 'text-[11px] text-gray-400'">
                    @if (out) {
                      {{ 'VARIANT_PICKER.OUT_OF_STOCK' | translate }}
                    } @else {
                      {{ stock }}
                    }
                  </span>
                }
              </button>
            }
          </div>
        </div>
      }

      <!-- Matched variant summary -->
      @if (matchedVariant(); as v) {
        <div
          class="flex items-center justify-between rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 p-3"
        >
          <div>
            <p class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ v.sku }}</p>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              {{ 'VARIANT_PICKER.IN_STOCK' | translate }}: {{ v.stock ?? 0 }}
            </p>
          </div>
          <span class="text-lg font-bold text-gray-900 dark:text-gray-100">
            {{ v.effectiveSellPrice | money: sellCurrency }}
          </span>
        </div>
      } @else if (m.attributes.length > 0) {
        <p class="text-sm text-gray-400 text-center">
          {{ 'VARIANT_PICKER.SELECT_HINT' | translate }}
        </p>
      }
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-2">
        <p-button
          [label]="'COMMON.CANCEL' | translate"
          severity="secondary"
          [text]="true"
          (onClick)="close()"
        />
        <p-button
          [label]="'VARIANT_PICKER.ADD' | translate"
          icon="pi pi-cart-plus"
          [disabled]="!matchedVariant() || (matchedVariant()?.stock ?? 0) <= 0"
          (onClick)="confirm()"
        />
      </div>
    </ng-template>
  } @else {
    <div class="py-10 text-center text-gray-400">
      {{ 'VARIANT_PICKER.EMPTY' | translate }}
    </div>
  }
</p-dialog>
